<template>
  <div class="app-404">
    <el-row :gutter="10" type="flex" align="middle" class="app-404-center">
      <el-col :span="12" style="height:100%">
        <svg-icon icon-class="icon-404" class-name="icon-big" />
      </el-col>
      <el-col :span="12" style="height:70%">
        <h1 style="font-weight:600;font-size:72px!important;margin:15px 0">
          400
        </h1>
        <p style="color:rgba(0,0,0,.45);font-size:20px!important;margin-bottom:15px">
          {{ $t('notFound.error') }}
        </p>
        <el-button type="primary" @click="toHome">
           {{ $t('notFound.backHome') }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>
<script>
export default {
  name: 'Page404',
  created() {
    this.$store.dispatch('delAllViews')
  },
  methods: {
    toHome() {
      this.$router.push({ path: '/' })
    }
  }
}
</script>
<style lang="scss" scoped>
h1,p{
  margin: 0;
}
  .app-404{
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    .app-404-center{
      width: 60%;
      height: 50%;
      // background: blue;
      .icon-big{
        width: 100%;
        height: 100%;
      }
    }
  }
</style>
